import { Label } from '@/components/ui/label'
import { ImageUploadField } from '@/components/ui/image-upload-field'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Button } from '@/components/ui/button'
import { useManagedOrganisationDetail, useOrganisations, type Organisation } from '@/hooks/use-organisations'
import {
  ArtifactCanvasBody,
  ArtifactCanvasFooterBar,
} from '@/components/artifact/artifact-canvas-layout'

interface OrganisationBannerCanvasProps {
  slug: string
  organisation: Organisation
  onClose: () => void
}

export function OrganisationBannerCanvas({ slug, organisation, onClose }: OrganisationBannerCanvasProps) {
  const { data: latestOrganisation } = useManagedOrganisationDetail(slug)
  const current = latestOrganisation ?? organisation
  const {
    uploadOrganisationBanner,
    deleteOrganisationBanner,
    isUploadingOrganisationBanner,
    isDeletingOrganisationBanner,
  } = useOrganisations()

  return (
    <ArtifactCanvasBody className="flex h-full min-h-0 flex-col space-y-0 p-0">
      <ScrollArea className="min-h-0 flex-1">
        <ArtifactCanvasBody className="space-y-6">
          <div className="space-y-2">
            <Label>Cover image</Label>
            <ImageUploadField
              variant="banner"
              serverImageUrl={current.banner_url}
              uploadBanner={(file) => uploadOrganisationBanner({ slug, file })}
              deleteBanner={() => deleteOrganisationBanner(slug)}
              isUploadingBanner={isUploadingOrganisationBanner}
              isDeletingBanner={isDeletingOrganisationBanner}
              persistenceNote={null}
            />
            <p className="text-xs text-muted-foreground">
              Choose an image to upload (PNG, JPEG, GIF, or WebP; max 5 MB). It saves when selected.
            </p>
          </div>
        </ArtifactCanvasBody>
      </ScrollArea>
      <ArtifactCanvasFooterBar
        actions={
          <Button type="button" variant="outline" onClick={onClose}>
            Close
          </Button>
        }
      />
    </ArtifactCanvasBody>
  )
}
